import posthog from 'posthog-js';

// Initialize PostHog
posthog.init('phc_yosXPA0oIurqBzZXeEasT9msjEPRoNEjZWw8rv20toG', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('PostHog loaded');
    }
  },
});

export default posthog;
